import { isClerkAPIResponseError } from "@clerk/shared";

/**
 * Checks if an error is a Clerk internal error thrown as a string rejection.
 *
 * Clerk's SDK can reject promises with plain strings like:
 *   "Object Not Found Matching Id:2, MethodName:update, ParamCount:4"
 *
 * These are internal Clerk state management errors (e.g., stale session references)
 * that are not actionable by the application — the best recovery is to reload.
 */
export function isClerkInternalError(error: unknown): boolean {
  return typeof error === "string" && error.startsWith("Object Not Found Matching Id:");
}

// Pulls the first Clerk API error code (e.g. "form_code_incorrect") off a rejected
// promise. Returns "" for non-Clerk errors so call sites can do a single lookup
// against the auth error_messages map without per-shape type assertions.
export function getClerkErrorCode(error: unknown): string {
  if (!isClerkAPIResponseError(error)) {
    return "";
  }
  return error.errors[0]?.code ?? "";
}
